import { Cake, CalendarDays, Trophy, Clock } from 'lucide-react';
import { EntityType } from '../../core/template.schemas';

export enum DefaultTemplateType {
  BIRTHDAY = 'BIRTHDAY',
  MATCH_ANNOUNCEMENT = 'MATCH_ANNOUNCEMENT',
  MATCH_HALFTIME = 'MATCH_HALFTIME',
  MATCH_RECAP = 'MATCH_RECAP',
}

export const DefaultTemplateConfig: Record<DefaultTemplateType, { label: string; entityType: EntityType; description: string; icon: any }> = {
  [DefaultTemplateType.BIRTHDAY]: {
    label: 'Geburtstag',
    entityType: 'Player',
    description: 'Dieses Template wird automatisch für Geburtstagsgrüße verwendet. Hinterlege hier dein Standard-Design für Spieler-Geburtstage, um direkt aus dem Dashboard mit einem Klick gratulieren zu können.',
    icon: Cake,
  },
  [DefaultTemplateType.MATCH_ANNOUNCEMENT]: {
    label: 'Spiel-Ankündigung',
    entityType: 'Match',
    description: 'Wird für die Vorschau auf kommende Spiele genutzt. Sobald ein Spiel im Dashboard erscheint, kannst du mit diesem Template sofort einen professionellen "Matchday"-Post erstellen.',
    icon: CalendarDays,
  },
  [DefaultTemplateType.MATCH_HALFTIME]: {
    label: 'Zwischenstand',
    entityType: 'Match',
    description: 'Wird für den Halbzeitstand verwendet. Erstelle schnell und einfach einen Post mit dem aktuellen Spielstand zur Pause.',
    icon: Clock,
  },
  [DefaultTemplateType.MATCH_RECAP]: {
    label: 'Endstand',
    entityType: 'Match',
    description: 'Wird für die Zusammenfassung nach dem Spiel verwendet. Ideal, um das Endergebnis und wichtige Statistiken schnell und ansprechend zu präsentieren.',
    icon: Trophy,
  },
};
